import styled, { css } from 'styled-components';
import breakpoints from '@repo/ui-components/breakpoints';
import styles from './utils/styles';

const FormCheck = styled.div``;

const ValidationMessage = styled.div`
  margin: 0.5rem 0;
  color: ${styles.colors.red[500]};
  display: none;
`;

const StyledForm = styled.form`
  font-size: 1rem;
  display: flex;
  flex-direction: column;

  input,
  select,
  textarea {
    background-color: ${styles.colors.white};
    font-size: inherit;
    border-radius: 0.25rem;
    border: solid 1px ${styles.colors.gray[300]};
    padding: 0.375rem 0.55rem;
    font-family: inherit;

    &::placeholder {
      color: ${styles.colors.gray[200]};
    }
  }

  textarea {
    min-height: 8rem;
    resize: vertical;
  }

  input[type='file'] {
    background: transparent;
    border: none;
    padding: 0;
    display: flex;
  }

  input[type='date'],
  select {
    height: 2.65rem;
    color: ${styles.colors.gray[500]};
  }

  label {
    font-size: inherit;
    display: flex;
    flex-direction: column;
    font-weight: 700;
    font-size: 1.125rem;
    input,
    select,
    textarea {
    }
  }

  ${FormCheck} {
    label {
      flex-direction: row;
      align-items: center;
    }
    input[type='radio'],
    input[type='checkbox'] {
      align-self: start;
      padding: 0;
      margin: 0;
      margin-top: 7px;
      margin-right: 0.5rem;
    }
    input[type='radio'] {
      margin-top: 4px;
    }
  }
`;

const FormRow = styled.div`
  margin-bottom: 1rem;
  width: 100%;

  /* Only apply custom widths when we exceed the breakpoint */
  @media screen and (min-width: ${breakpoints.sm}) {
    width: ${({ width }) => (width ? `${width}%` : 'auto')};
  }

  ${({ invalid }) =>
    invalid &&
    css`
      ${StyledForm} & {
        ${ValidationMessage} {
          display: block;
        }
      }
    `}
  ${({ valid }) =>
    valid &&
    css`
      ${StyledForm} & {
        label,
        input,
        select,
        textarea {
          color: ${styles.colors.green[500]};
          border-color: ${styles.colors.green[500]};
        }
      }
    `};
`;

export { StyledForm, FormRow, FormCheck, ValidationMessage };
